import _ from "lodash";

import { http } from "@/utils/http";

/** 获取订单信息 /bi/query */
export const orderBi = data => {
  return http.request("post", "/biz/order/bi/query", { data });
};

/**
 * 取消订单
 * @param {order id} _id
 * @returns
 */
export const cancelOrder = async _id => {
  const res = await http.post("biz/open_order/cancel", {
    data: {
      preferred: {
        version: "v2"
        // currency: getCurrency(),
      },
      _id
    }
  });
  return res;
};

/**
 * 取消订单
 * @param {orderRef} orderRef
 * @returns
 */
export const requestCancelOrder = async orderRef => {
  const res = await http.post("/biz/order/modify/status/cancel/request", {
    data: { orderRef }
  });
  return res;
};

/**
 * 发送emial
 * @param {} orderRef
 * @param {Object} extraData
 * @returns
 */
export const sendEmail = async (orderRef, extraData = {}) => {
  const res = http.post("biz/order/print/email", {
    data: { orderRef, ...extraData }
  });
  return res;
};

/**
 * 订单通知
 * @param {} data
 * @returns
 */
export const notifyEmail = async (data = {}) => {
  const res = http.post("biz/order/notify/email", {
    data
  });
  return res;
};

export const previewConfirmation = async (data = {}) => {
  const res = http.post("biz/order/notify/preview", {
    data
  });
  return res;
};

/**
 * 获取pdf Url
 * @param {*} orderRef
 * @returns
 */
export const getOrderPdfUrl = async orderRef => {
  const bookRes = await http.get("rest/books", {
    query: JSON.stringify({
      orderRef,
      type: "confirmation"
    })
  });
  const url = _.get(bookRes, "0.published.url");
  return url;
};

/**
 * 挂帐
 * @param {*} orderRef
 * @returns
 */
export const payOrderByOffline = async orderRef => {
  const res = await http.post("/biz/order/pay/sign", {
    data: {
      orderRef,
      paymentType: "offlineCredit"
    }
  });
  return res;
};

// /biz/open_order/search

export const getOrders = async query => {
  const res = await http.post("/booking/order/search", { data: query });
  return res;
};

/**
 * 总套询价
 * @param {*} data
 * @returns
 */
export const updateOrderNegotiate = async data => {
  const res = await http.post("/biz/order/modify/vendor/negotiate", { data });
  return res;
};

/**
 * 取消驳回
 * @param {*} orderRef
 * @returns
 */
export const orderCancelReject = async orderRef => {
  const res = await http.post("/biz/order/modify/status/cancel/reject", {
    data: {
      orderRef
    }
  });
  return res;
};

/**
 * 同意取消
 * @param {String} orderRef
 * @param {Boolean} forceCancel 是否强制取消
 * @returns
 */
export const orderCancelApprove = async (orderRef, forceCancel = false) => {
  const res = await http.post("/biz/order/modify/status/cancel/approve", {
    data: {
      orderRef,
      forceCancel
    }
  });
  return res;
};
